<template lang="pug">
  v-text-field(
    v-bind="$attrs"
    v-money="money"
    v-model="model"
    :rules="rules")
</template>

<script>
import { VMoney } from 'v-money'
import { computed } from '@vue/composition-api'

export default {
  directives: {
    money: VMoney
  },

  props: {
    rules: Array
  },

  setup (props, { emit }) {
    const model = computed({
      get: () => props.value,
      set: value => {
        const input = parseInt(value.replace(/ |,/g, ''))
        emit(`input`, input)
      }
    })

    return {
      model,
      money: {
        decimal: ',',
        thousands: ' ',
        suffix: '€',
        precision: 2
      }
    }
  }
}
</script>
